<template>
    <div>
        <b-alert :show="isToShowEmptyListAlert" class="m-0 mb-3">
            <span>{{ $t('isEmptyAlert') }}</span>
        </b-alert>
        <div v-if="!isToShowEmptyListAlert" class="d-flex dashs">
            <OkriDashboard @selected="okriFilter = $event" :filters="filters" allOkrs />
            <InitiativeDashboard v-if="hasDaily" @selected="initiativesFilter = $event" />
            <ExpandAllOkrsBtn @expandToggle="expandAllToggle = !expandAllToggle" />
        </div>
        <ObjectiveDetails
            v-on="$listeners"
            v-bind="$attrs"
            v-for="objective in objectives"
            :key="objective.id"
            :objective="objective"
            @onClickNewKeyResult="openNewKeyResultModalCallback"
            :okriFilter="okriFilter"
            :initiativesFilter="initiativesFilter"
            @onChangeInitiative="$emit('onChangeInitiative')"
            :expandAllToggle="expandAllToggle"
        />
        <div
            v-if="showCreateObjectiveBtn"
            id="btn-daily-initiatives-profile-new-objective"
            class="pt-1 border-start-objective"
            @click="$bvModal.show('new-objective-modal')"
        >
            <img src="@/assets/icons/create-initiative.svg" />
            {{ $t('objectives.createObjective') }}
        </div>
        <b-row align-v="center">
            <b-col cols="1">
                <PaginationPerPage
                    slot="per-page"
                    v-model="pagination.perPage"
                    @input="$emit('onChangePerPage', $event)"
                />
            </b-col>
            <b-col cols="10">
                <Pagination
                    v-model="pagination.currentPage"
                    :total="pagination.totalItems"
                    :per-page="pagination.perPage"
                    @input="$emit('onChangePage', $event)"
                />
            </b-col>
        </b-row>
        <NewKeyResult
            @onCreatedKeyResult="$listeners.onCreatedKeyResult"
            @openModal="openNewKeyResultModalCallback = $event"
        />
    </div>
</template>

<script>
import { ObjectiveDetails } from '@/views/okr/daily'
import NewKeyResult from '@/views/okr/key-result/new'
import OkriDashboard from '@/views/okr/daily/dashboard'
import InitiativeDashboard from '@/views/okr/daily/initiatives/dashboard'
import Pagination, { PaginationPerPage } from '@/views/components/pagination'
import { ExpandAllOkrsBtn } from '@/views/okr/components'
import { includes } from 'lodash'
import { mapState } from 'vuex'

export default {
    name: 'Okrs',
    components: {
        ObjectiveDetails,
        NewKeyResult,
        OkriDashboard,
        InitiativeDashboard,
        Pagination,
        PaginationPerPage,
        ExpandAllOkrsBtn,
    },
    props: {
        objectives: {
            type: Array,
            required: true,
        },
        pagination: {
            type: Object,
            required: true,
            default: () => ({
                perPage: 10,
                totalItems: 0,
                currentPage: 1,
            }),
        },
        filters: {
            type: Object,
        },
    },
    data() {
        return {
            openNewKeyResultModalCallback: () => {},
            okriFilter: [],
            initiativesFilter: [],
            expandAllToggle: false,
        }
    },
    computed: {
        ...mapState('profile', ['user']),
        hasDaily() {
            return includes(this.user.has_modules, 'has_daily')
        },
        isToShowEmptyListAlert() {
            return this.objectives.length === 0
        },
        showCreateObjectiveBtn() {
            return this.okriFilter.includes('objectives')
        },
    },
    created() {
        this.updatePagination()
    },
    methods: {
        updatePagination() {
            this.$emit('update:pagination', this.pagination)
        },
    },
    i18n: {
        messages: {
            'en-US': {
                isEmptyAlert: "You don't have any OKR yet.",
            },
            'es-ES': {
                isEmptyAlert: 'Aún no tienes OKR.',
            },
            'pt-BR': {
                isEmptyAlert: 'Você ainda não possui OKRs.',
            },
        },
    },
}
</script>
<style scoped>
#btn-daily-initiatives-profile-new-objective {
    display: flex;
    gap: 0.5rem;
    align-content: center;
    color: #009ada;
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    font-size: 0.9rem;
    padding-top: 0.6rem !important;
    padding-bottom: 0.6rem;
    cursor: pointer;
}
#btn-daily-initiatives-profile-new-kr:hover {
    background: #ececec;
}

::v-deep .border-start-objective {
    border-left: 4px solid #022b4f;
    padding-left: 0.7rem !important;
    padding: 0.3rem 0 0.3rem 0;
}

::v-deep .border-start-objective:hover {
    background: #ececec;
}

@media screen and (max-width: 1200px) {
    .dashs {
        flex-direction: column;
    }
}
</style>
